import GridCardLandingSkeleton from "@shared/components/card/skeleton/grid-card-landing-skeleton";
import GridCardSkeleton from "@shared/components/card/skeleton/grid-card-skeleton";
import ListCardSkeleton from "@shared/components/card/skeleton/list-card-skeleton";

import { EXPLORE_SLUG } from "types/api/explore";
import TeacherCardSkeleton from "./teacher-card/skeleton";

interface Props {
  skeletonCount: number;
  slug?: EXPLORE_SLUG;
  isMobile?: boolean;
}

const component = (isMobile: boolean) => ({
  [EXPLORE_SLUG.COURSE]: isMobile ? (
    <ListCardSkeleton withBorder={false} />
  ) : (
    <GridCardSkeleton />
  ),
  [EXPLORE_SLUG.LANDING]: isMobile ? (
    <ListCardSkeleton withBorder={false} />
  ) : (
    <GridCardLandingSkeleton />
  ),
  [EXPLORE_SLUG.INSTRUCTOR]: <TeacherCardSkeleton />,
});

const ExploreSkeletonLoading: React.FC<Props> = ({
  skeletonCount,
  slug = EXPLORE_SLUG.COURSE,
  isMobile,
}) => {
  return (
    <>
      <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-4    ">
        {Array(skeletonCount)
          .fill(0)
          .map((_, index) => (
            <div
              key={`sekeleton-item-${index}`}
              className="col-span-1 mt-2.5   mb-6"
            >
              {component(isMobile || false)[slug]}
            </div>
          ))}
        <div className="w-full col-span-1 sm:col-span-2 lg:col-span-3 flex justify-center items-center mt-4 ml-2.5">
          <div className="p-2 w-[302px] h-10 bg-neutral animate-pulse"></div>
        </div>
      </div>
    </>
  );
};

export default ExploreSkeletonLoading;
